<template lang="pug">
v-main
    v-card(style="padding: 20px; height: 100%")
        v-tabs(color="white", slider-color="red", left )
            v-tab(
                style='background-color:white !important'
                @click="tab0 = true; tab1 = false; getData(0)"
            ) Need Approval to Pak Mosu
            v-tab(
                style='background-color:white !important'
                @click="tab0 = false; tab1 = true; getData(1)"
            ) Approved by Pak Mosu and Need Approval to Pak Fu
        IMListBOD(
            :im="dataIm"
            :loading="isLoadingData"
        )
</template>

<script>
import IMListBOD from '../components/IMListBOD.vue';
import axios from "axios";

export default {
  name: "ApprovalBOD",
  components: {
    IMListBOD
  },
  data() {
    return {
      tab0: true,
      tab1: false,
      isLoadingData: false,
      dataIm: {
        headers: [
            {
                text: "IM No",
                value: "imNo",
            },
            {
                text: "Created Date",
                value: "imDate",
            },
            {
                text: "Creator Name",
                value: "imUser.name",
            },
            {
                text: "Creator Email",
                value: "imUser.email",
            },
            {
                text: "BU Name",
                value: "imOrganization.name",
            },
            {
                text: "Subject",
                value: "imPerihal",
            },
            {
                text: "QR Code",
                value: "link_qr.qrcode",
            },
        ],
        items: []
      },
    };
  },
  mounted() {
    this.getData(0)
  },
  methods: {
    async getData(tabNo) {
        this.isLoadingData = true
        axios.get(process.env.VUE_APP_API_OLD+`/api/requests/bod/${tabNo}`, {headers: {
            Authorization: 'Bearer ' + localStorage.getItem("token")
        }})
            .then((res) => {
                this.dataIm.items = res.data
            })
            .finally(() => this.isLoadingData = false)
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:last-child,
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:last-child,
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-top: thin solid rgba(0, 0, 0, 0.12);
}

.v-tab.v-tab {
  color: black;
}
.v-tabs__item {
  color: #ffffff;
}

.v-tabs__item--active {
  color: #333;
}
</style>
